import React from 'react'

function LegalContent() {
  return (
    <div className="flex w-full flex-col px-8 py-24">
      <div className="flex w-full max-w-[720px] flex-col gap-12">
        <p className="text-[18px] leading-[28px] text-[#535862]">
          Mi tincidunt elit, id quisque ligula ac diam, amet. Vel etiam suspendisse morbi
          eleifend faucibus eget vestibulum felis. Dictum quis montes, sit sit. Tellus aliquam
          enim urna, etiam. Mauris posuere vulputate arcu amet, vitae nisi, tellus tincidunt. At
          feugiat sapien varius id.<br /><br />
          Eget quis mi enim, leo lacinia pharetra, semper. Eget in volutpat mollis at volutpat
          lectus velit, sed auctor. Porttitor fames arcu quis fusce augue enim. Quis at habitant
          diam at. Suscipit tristique risus, at donec. In turpis vel et quam imperdiet. Ipsum
          molestie aliquet sodales id est ac volutpat.
        </p>

        <div className="flex flex-col gap-5">
          <h2 className="text-3xl font-semibold text-[#181d27]">What information do we collect?</h2>
          <p className="text-[18px] leading-[28px] text-[#535862]">
            Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio nisl vitae. In
            aliquet pellentesque aenean hac vestibulum turpis mi bibendum diam. Tempor integer
            aliquam in vitae malesuada fringilla.<br /><br />
            Elit nisi in eleifend sed nisi. Pulvinar at orci, proin imperdiet commodo consectetur
            convallis risus. Sed condimentum enim dignissim adipiscing faucibus consequat, urna.
            Viverra purus et erat auctor aliquam. Risus, volutpat vulputate posuere purus sit
            congue convallis aliquet. Arcu id augue ut feugiat donec porttitor neque. Mauris,
            neque ultricies eu vestibulum, bibendum quam lorem id. Dolor lacus, eget nunc lectus
            in tellus, pharetra, porttitor.<br /><br />
            Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non
            pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam
            elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel,
            congue felis elit erat nam nibh orci.
          </p>
        </div>

        <div className="flex flex-col gap-5">
          <h2 className="text-3xl font-semibold text-[#181d27]">How do we use your information?</h2>
          <p className="text-[18px] leading-[28px] text-[#535862]">
            Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio nisl vitae. In
            aliquet pellentesque aenean hac vestibulum turpis mi bibendum diam. Tempor integer
            aliquam in vitae malesuada fringilla.<br /><br />
            Elit nisi in eleifend sed nisi. Pulvinar at orci, proin imperdiet commodo consectetur
            convallis risus. Sed condimentum enim dignissim adipiscing faucibus consequat, urna.
            Viverra purus et erat auctor aliquam. Risus, volutpat vulputate posuere purus sit
            congue convallis aliquet. Arcu id augue ut feugiat donec porttitor neque. Mauris,
            neque ultricies eu vestibulum, bibendum quam lorem id. Dolor lacus, eget nunc lectus
            in tellus, pharetra, porttitor.<br /><br />
            Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non
            pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam
            elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel,
            congue felis elit erat nam nibh orci.
          </p>
        </div>

        <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-semibold text-[#181d27]">Do we use cookies and other tracking technologies?</h2>
          <p className="text-[18px] leading-[28px] text-[#535862]">
            Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam
            ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu.
            Maecenas est morbi mattis id in ac pellentesque ac.
          </p>
        </div>

        <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-semibold text-[#181d27]">How long do we keep your information?</h2>
          <p className="text-[18px] leading-[28px] text-[#535862]">
            Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam
            ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu.
            Maecenas est morbi mattis id in ac pellentesque ac.
          </p>
        </div>

        <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-semibold text-[#181d27]">How do we keep your information safe?</h2>
          <p className="text-[18px] leading-[28px] text-[#535862]">
            Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam
            ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu.
            Maecenas est morbi mattis id in ac pellentesque ac.
          </p>
        </div>

        <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-semibold text-[#181d27]">What are your privacy rights?</h2>
          <p className="text-[18px] leading-[28px] text-[#535862]">
            Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis aliquam
            ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget a, elementum eu.
            Maecenas est morbi mattis id in ac pellentesque ac.
          </p>
        </div>

        <div className="flex flex-col gap-5">
          <h2 className="text-3xl font-semibold text-[#181d27]">How can you contact us about this policy?</h2>
          <p className="text-[18px] leading-[28px] text-[#535862]">
            Sagittis et eu at elementum, quis in. Proin praesent volutpat egestas sociis sit lorem
            nunc nunc sit. Eget diam curabitur mi ac. Auctor rutrum lacus malesuada massa ornare
            et. Vulputate consectetur ac ultrices at diam dui eget fringilla tincidunt. Arcu sit
            dignissim massa erat cursus vulputate gravida id. Sed quis auctor vulputate hac
            elementum gravida cursus dis.<br /><br />
            Lectus id duis vitae porttitor enim gravida morbi.<br /><br />
            Eu turpis posuere semper feugiat volutpat elit, ultrices suspendisse. Auctor vel in
            vitae placerat.<br /><br />
            Suspendisse maecenas ac donec scelerisque diam sed est duis purus.
          </p>
        </div>
      </div>
    </div>
  )
}

export default LegalContent
